/**
 * Breakpoints in px for TypeScript. Mirrors screen.scss: Turbopack does not support Sass `:export`,
 * so screen.module.scss resolves to an empty object in production builds. A test keeps the two in sync.
 */
export const SCREEN = {
  screenXXs: 320,
  screenXs: 480,
  screen568: 568,
  screen640: 640,
  screenS: 768,
  screenM: 1024,
  screen1126: 1126,
  screenL: 1440,
} as const;
